import React from 'react';
import {
  Alert, Button, Form, InputGroup, Row, Col,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateTimePicker, } from '@payit/cool-web-ui-library';
import AsyncActionButton from '../../button/AsyncActionButton';
import Conversation from './Conversation';
import TalkBoxService from '../../../service/TalkBoxService';
import CustomerProfileService from '../../../service/CustomerService';
import CustomerModalWithoutResetOption from '../CustomerProfile/CustomerModalWithoutResetOption';
import '../View.css';
import './ConversationViewer.css';

class ConversationViewer extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.searchCall = this.searchCall.bind(this);

    this.state = {
      input: '',
      formError: '',
      status: '',
      showConvo: false,
      isLoading: false,
      value: null,
      value2: null,
      conversations: [],
      customerInformation: null,
    };
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  onChange = date => {
    this.setState({ value: date, });
  };

  onChange2 = date => {
    this.setState({ value2: date, });
  };

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  getCustomerInformation(customerId) {
    const criteria = {};
    criteria.customerId = customerId;

    CustomerProfileService.getCustomers(criteria)
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({
            customerInformation: response.data.customer,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  getConversation(input) {
    this.reset();
    const { requestedState = {}, } = this.props;
    const { id = '', } = requestedState;
    const regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    let customerId;
    if (id && !input) {
      customerId = id;
    } else {
      customerId = input;
    }

    this.getCustomerInformation(customerId);

    if (!regexGuid.test(customerId)) {
      this.setState({ formError: <p>You must enter a valid UUID!</p>, });
    } else if (this.state.value > this.state.value2 && this.state.value !== null && this.state.value2 !== null) {
      this.setState({ formError: <p>Ending date is before starting date!</p>, });
    } else {
      this.searchCall({ customerId, offset: 0, limit: 25, });
    }
  }

  handleHide = () => {
    this.setState({ status: '', });
  };

  searchCall(conversationSearchRequest) {
    const { conversations, } = this.state;
    const copiedRequest = { ...conversationSearchRequest, };

    const convo = copiedRequest.offset === 0 ? [] : conversations;
    let isMoreRecords = false;
    this.setState({
      isLoading: true,
    });
    TalkBoxService.conversationSearch(copiedRequest)
      .then(({ data, }) => {
        const x = data.data.conversations;
        let value = x;
        if (this.state.value !== null && this.state.value2 !== null) {
          const temp = x.filter(conversation => moment(conversation.creationDate) >= (moment(this.state.value).tz('America/Chicago', true)));
          value = temp.filter(conversation => moment(conversation.creationDate) <= (moment(this.state.value2).tz('America/Chicago', true)));
        }
        if (this.state.value !== null && this.state.value2 === null) {
          value = x.filter(conversation => moment(conversation.creationDate) >= (moment(this.state.value).tz('America/Chicago', true)));
        }
        if (Array.isArray(value) && value.length > 0) {
          const list = convo.concat(value);
          this.setState({
            conversations: list,
            showConvo: true,
            isLoading: false,
          });

          if (value.length === 25) {
            copiedRequest.offset += copiedRequest.limit;
            isMoreRecords = true;
          }
        }
      })
      .catch(() => {
        this.setState({
          status: (
            <Alert className="mt-2" variant="danger">
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
              <p>Error!</p>
              <div className="d-flex justify-content-end">
                <Button onClick={this.handleHide} variant="outline-danger">
                  OK
                </Button>
              </div>
            </Alert>
          ),
        });
      })
      .finally(() => {
        this.setState({
          lastSearch: isMoreRecords ? copiedRequest : null,
          isLoading: false,
        });
      });
  }

  handleChange(event) {
    this.setState({ input: event.target.value, });
  }

  reset() {
    this.setState({
      formError: '',
      status: '',
      showConvo: false,
      isLoading: false,
      conversations: [],
    });
  }

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const {
      input,
      formError,
      status,
      showConvo,
      isLoading,
      conversations,
      lastSearch = null,
      customerInformation,
    } = this.state;

    const { sendNavigationRequest, } = this.props;

    return (
      <div className="content">
        <Row className="justify-content-center">
          <Col lg={5}>
            <InputGroup className="mt-2">
              <Form.Control
                type="input"
                placeholder="Enter a customer Id"
                onChange={event => this.handleChange(event)}
                className="me-2"
              />
              <AsyncActionButton
                onClick={() => this.getConversation(input)}
                clickConsumer={click => this._setClickEvent(click)}
                contents="Get Conversation"
                isLoading={isLoading}
                variant="success"
                loadingVariant="secondary"
                className="me-2"
              />
              <CustomerModalWithoutResetOption
                customer={customerInformation}
                sendNavigationRequest={sendNavigationRequest}
              />
            </InputGroup>
          </Col>
        </Row>
        <div className="Date">
          <div className="DatePicker">
            <DateTimePicker
              {...this.props}
              value={this.state.value}
              onChange={this.onChange}
              timeHint="Central time"
            />
          </div>
          <span>---------</span>
          <div className="DatePicker">
            <DateTimePicker
              {...this.props}
              value={this.state.value2}
              onChange={this.onChange2}
              timeHint="Central time"
            />
          </div>
          <p>
            <span>{this.state.value ? (moment(this.state.value).tz('America/Chicago', true)).utc().format('MMM Do, YYYY, hh:mm A') : 'Start'}</span>
            <span>---------</span>
            <span>{this.state.value2 ? (moment(this.state.value2).tz('America/Chicago', true)).utc().format('MMM Do, YYYY, hh:mm A') : 'End'}</span>
          </p>
          {formError}
        </div>
        {status}
        <div className="convo-container">
          {showConvo ? (
            <>
              <Conversation conversations={conversations} />
              <div className="p-2">{`Total conversations: ${conversations.length}`}</div>
              <button
                type="button"
                disabled={lastSearch === null}
                onClick={() => this.searchCall(lastSearch)}
                className="btn btn-link"
              >
                Load more
              </button>
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

ConversationViewer.defaultProps = {
  requestedState: undefined,
};

ConversationViewer.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
  sendNavigationRequest: PropTypes.func.isRequired,
};

export default ConversationViewer;
